export enum SearchTypeKey {
  BeginsWith = "BeginsWith",
  Contains = "Contains",
  ExactMatch = "ExactMatch",
  NotContains = "NotContains",
}

export enum SearchTypeTranslateKey {
  BeginsWith = "beginsWith",
  ExactMatch = "exactlyMatches",
  Contains = "contains",
  NotContains = "doesNotContain",
}
